export default __webpack_public_path__ + "static/media/oscer-pres-breast-pain.0fda6eed.svg";